import { MenuItem } from "@mui/material";
import useOpenInWhatsapp, {
  OpenProposalInWhatsappProps,
} from "@/modules/property-tracks/hooks/rental-financial-proposal/open-in-whatsapp.hook";

export default function OpenInWhatsapp(props: OpenProposalInWhatsappProps) {
  const { handleWhatsapp, isLoading, canOpenWhatsapp, disabledReason } =
    useOpenInWhatsapp(props);

  return (
    <>
      <MenuItem
        sx={(t) => t.nawy.typography.english.variants.body.md.regular}
        disabled={isLoading || !canOpenWhatsapp}
        title={!canOpenWhatsapp ? disabledReason : undefined}
        onClick={() => {
          handleWhatsapp();
        }}
      >
        WhatsApp
      </MenuItem>
    </>
  );
}
